import { constantRouterMap } from '@/router/index';
import { getRouters,currentRouting } from '@/utile/RouterUtils';
import { getRole,setRollback,removeToken,removeRole,removeNavigationId,removeMenuBar } from "@/utile/auth.js";
import router from "../../router"
const user = {
  state:{
    routers: constantRouterMap,
    addRouters: []
  },
  mutations:{
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions:{
    //获取权限
    GetUserInfo({ commit }){
      return new Promise((resolve,reject)=>{
        let role = JSON.parse(getRole());
        const asyncRouterMap = getRouters(role);
        asyncRouterMap.push({ path: '*', redirect: '/404', hidden: true });
        commit('SET_ROUTERS', asyncRouterMap);
        let nexRouter = currentRouting(asyncRouterMap);
        setRollback(nexRouter);
        router.addRoutes(constantRouterMap.concat(asyncRouterMap));
        resolve(nexRouter);
      })
    },
    //退出登录
    logOut({ commit }){
      return new Promise((resolve,reject)=>{
        commit('SET_ROUTERS',[]);
        removeToken();
        removeRole();
        removeNavigationId();
        removeMenuBar();
        //加入页面刷新及路由重定向为了清除路由信息
        router.replace({path: '/'});
        location.reload();
        resolve();
      })
    }
  }
}
export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js